<script>
  import { urbanColors } from "@urbaninstitute/dataviz-components/utils";
  let { fill = urbanColors.gray, size = 48 } = $props();
</script>

<svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M47.6745 12.5486C47.8972 12.8454 48 13.1771 48 13.5436C48 13.9102 47.8972 14.207 47.6745 14.4339L24.9764 37.6683C24.6852 37.8953 24.3597 38 24 38C23.6403 38 23.349 37.8953 23.1263 37.6683L0.325482 14.4339C0.102784 14.207 0 13.9102 0 13.5436C0 13.1771 0.102784 12.8454 0.325482 12.5486L2.50107 10.3317C2.70664 10.1047 2.99786 10 3.37473 10C3.75161 10 4.05996 10.1047 4.35118 10.3317L24.0171 30.3716L43.666 10.3317C43.9572 10.1047 44.2827 10 44.6424 10C45.0021 10 45.2934 10.1047 45.5161 10.3317L47.6745 12.5486Z"
    {fill}
  />
</svg>
